import React from 'react';
import './IconDescription.css';
import streuer from '../resources/streuer.png';
import zubehoer from '../resources/zubehoer.png';
import aufsatz from '../resources/aufsatz.png';

interface IIconDescriptionProps {
}

interface IIconDescriptionState {
}

export default class IconDescription extends React.Component<IIconDescriptionProps, IIconDescriptionState>{

    render() {
        return (
            <div id="icon-descriptions">

                <div id="zubehoer" className="wrapper">

                    <div className="icon-card bordered">

                        <img className="icon" src={zubehoer} />
                        <p className="description-text">
                            <h3>Düngerstreuer Zubehör: Neu oder Gebraucht und Aufbereitet</h3>
                            <ul>
                                <li>Streuscheiben (10-24m/ 24-36m)</li>
                                <li>Grenzstreuscheiben</li>
                                <li>Grenzstreuschirme für das Grenzstreuen vom Feldrand</li>
                                <li>Limiter für das Grenzstreuen aus der Fahrgasse</li>
                                <li>Kompatibel mit Amazone Düngerstreuern der Baureihe ZAM</li>
                            </ul>
                        </p>

                    </div>

                </div>

                <div id="streuer" className="wrapper">

                    <div className="icon-card bordered">

                        <img className="icon" src={streuer} />
                        <p className="description-text">
                            <h3>Düngerstreuer Voll- und Teilrestauriert</h3>
                            <ul>
                                <li>Ersatz aller Verschleißteile</li>
                                <li>Beheben von Rostschäden</li>
                                <li>Sandstrahlen und Lackieren</li>
                                <li>Kontrolle und ggf. Ersatz funktionaler Bauteile</li>
                            </ul>
                        </p>

                    </div>

                </div>

                <div id="aufsatz" className="wrapper">

                    <div className="icon-card">

                        <img className="icon" src={aufsatz} />
                        <p className="description-text">
                            <h3>Eigenkonstruierte Aufbauten</h3>
                            <ul>
                                <li>Tatsächliches Füllvolumen 750l, 1150l und 1450l</li>
                                <li>Zwei eingebaute Sichtfenster</li>
                                <li>Kompatibel mit Amazone Düngerstreuern der Baureihen ZAM und ZAU</li>
                                <li>Mit und ohne Abdeckschwenkplane (Abdeckschwenkplane auch einzeln erhältlich)</li>
                            </ul>
                        </p>

                    </div>

                </div>

            </div>
        )
    }

}